const doc = document.implementation.createHTMLDocument('')
const div = doc.createElement('div')

const safeHTML = (htmlString) => {
  if (!htmlString || typeof htmlString !== 'string') return ''

  try {
    div.innerHTML = htmlString

    for (let elements = div.querySelectorAll('*'), i = elements.length - 1; i >= 0; i--) {
      let element = elements[i],
        tagName = element.localName

      if (tagName == 'script' || tagName == 'noscript' || tagName == 'noembed' || !(element.attributes instanceof NamedNodeMap)) {
        try {
          element.parentNode.removeChild(element)
        } catch {
          element.outerHTML = ''
        }
        continue
      }

      if (!element.hasAttributes()) continue
    }

    return div.innerHTML
  } catch {
    return ''
  }
}

export default {
  install(app) {
    app.directive('html-safe', {
      mounted(el, binding) {
        if (binding.value) {
          el.innerHTML = safeHTML(binding.value)
        }
      },
      updated(el, binding) {
        if (binding.value !== binding.oldValue) {
          el.innerHTML = safeHTML(binding.value)
        }
      },
    })
  },
}
